import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  topics: [],
  scripts: [],
  lastFetched: null,
};

const topicsSlice = createSlice({
  name: 'topics',
  initialState,
  reducers: {
    fetchTopicsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTopicsSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.topics = action.payload.topics || [];
      state.scripts = action.payload.scripts || [];
      state.lastFetched = Date.now();
    },
    fetchTopicsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.topics = [];
      state.scripts = [];
    },
    clearTopics: (state) => {
      state.loading = false;
      state.error = null;
      state.topics = [];
      state.scripts = [];
      state.lastFetched = null;
    },
  },
});

export const {
  fetchTopicsStart,
  fetchTopicsSuccess,
  fetchTopicsFailure,
  clearTopics,
} = topicsSlice.actions;

export default topicsSlice.reducer;

